export default {
    header: "Zostałeś pomyślnie wylogowany",
    message: ""
}